export const ABLY_INFO = {
  name: '에이블리',
  address: '서울특별시 성동구 성수이로24길 8, 에이블리 임팩센터 안내데스크',
  tel: '1833-8021',
  corporateRegistrationNumber: '164-87-00149',
  email: 'support@a-bly.com',
  kakaoChannelId: '_cSvSK',
  kakaoChannelName: '@에이블리_고객지원센터',
  officeHours: '10:00 ~ 18:00',
  lunchHours: '12:30 ~ 13:30',
  appStore: 'itms-apps://itunes.apple.com/app/id1084960428 ',
  googlePlay:
    'https://play.google.com/store/apps/details?id=com.banhala.android&hl=ko',
  // 가로형
  ogImage: 'https://img.a-bly.com/og_image.jpg',
  // 정사각형
  kakaoDefaultImage: 'https://img.a-bly.com/kakao_og_image.jpg',
  mailOrderBusinessReportNumber: '2021-서울서초-2450',
  url: 'https://m.a-bly.com',
} as const;
